import { render, staticRenderFns } from "./prueba_componente.vue?vue&type=template&id=57f445c8&scoped=true"
var script = {}
import style0 from "./prueba_componente.vue?vue&type=style&index=0&id=57f445c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f445c8",
  null
  
)

export default component.exports